import { TechnicianTimesheet } from "../../Api/technicianTimesheet";
import {
  FETCH_TIMESHEET_FAILURE,
  FETCH_TIMESHEET_SUCCESS,
  FETCH_TIMESHEET_REQUEST,
  SAVE_TIMESHEET_REQUEST,
  SAVE_TIMESHEET_SUCCESS,
  SAVE_TIMESHEET_FAILURE,
  SAVE_TECHNICIANWORKHOURS_FAILURE,
  SAVE_TECHNICIANWORKHOURS_SUCCESS,
  SAVE_TECHNICIANWORKHOURS_REQUEST,
} from "../../Constants";

function requestTimesheet() {
  return {
    type: FETCH_TIMESHEET_REQUEST,
    isFetching: true,
  };
}

function timesheetDataSuccess(data) {
  return {
    type: FETCH_TIMESHEET_SUCCESS,
    isFetching: false,
    data,
  };
}

function timesheetError(errorMessage) {
  return {
    type: FETCH_TIMESHEET_FAILURE,
    isFetching: false,
    errorMessage,
  };
}

function saveTimesheetTechnicianrequest() {
  return {
    type: SAVE_TIMESHEET_REQUEST,
    isFetching: true,
  };
}

function savetimesheetDataSuccess(data) {
  return {
    type: SAVE_TIMESHEET_SUCCESS,
    isFetching: false,
    data,
  };
}
function saveTechnicianWorkHoursSuccess(data) {
  return {
    type: SAVE_TECHNICIANWORKHOURS_SUCCESS,
    isFetching: false,
    data,
  };
}
function saveTechnicianWorkHoursRequest() {
  return {
    type: SAVE_TECHNICIANWORKHOURS_REQUEST,
    isFetching: true,
  };
}
function saveTechnicianWorkHoursfailure(data) {
  return {
    type: SAVE_TECHNICIANWORKHOURS_FAILURE,
    isFetching: false,
    data,
  };
}

function savetimesheetError(errorMessage) {
  return {
    type: SAVE_TIMESHEET_FAILURE,
    isFetching: false,
    errorMessage,
  };
}
// function saveTechnicianCalloutRequest() {
//   return {
//     type: SAVE_TECHNICIANCALLOUTSAVE_REQUEST,
//     isFetching: true
//   };
// }

// function saveTechnicianCalloutSuccess(data) {
//   return {
//     type: SAVE_TECHNICIANCALLOUTSAVE_SUCCESS,
//     isFetching: false,
//     data
//   };
// }

// function saveTechnicianCalloutError(errorMessage) {
//   return {
//     type: SAVE_TECHNICIANCALLOUTSAVE_FAILURE,
//     isFetching: false,
//     errorMessage
//   };
// }

//Fetch WorkHours for particular day
export const getTimesheetData = (payload) => (dispatch, getState) => {
  dispatch(requestTimesheet());
  TechnicianTimesheet.fetchTimesheetData(payload)
    .then((res) => {
      dispatch(timesheetDataSuccess(res));
    })
    .catch((err) => dispatch(timesheetError(err)));
};
export const getCentralTimesheetData = (payload) => (dispatch, getState) => {
  dispatch(requestTimesheet());
  TechnicianTimesheet.fetchCentralTimesheetData(payload)
    .then((res) => {
      dispatch(timesheetDataSuccess(res));
    })
    .catch((err) => dispatch(timesheetError(err)));
};

//save timesheet data from monthview
export const saveTimesheetData = (payload) => (dispatch, getState) => {
  dispatch(saveTimesheetTechnicianrequest());
  TechnicianTimesheet.updateTimesheetData(payload)
    .then((res) => {
      dispatch(savetimesheetDataSuccess(res));
    })
    .catch((err) => dispatch(savetimesheetError(err)));
};

//Save Technician Working hours
export const saveTechnicianWorkHours = (payload) => (dispatch, getState) => {
  dispatch(saveTechnicianWorkHoursRequest());
  TechnicianTimesheet.updateTimesheetDataPopup(payload)
    .then((res) => {
      dispatch(saveTechnicianWorkHoursSuccess(res));
    })
    .catch((err) => dispatch(saveTechnicianWorkHoursfailure(err)));
};

export const resetsaveTimesheetMessage = (payload) => (dispatch, getState) => {
  dispatch(savetimesheetDataSuccess(""));
};

//Save Technician Call Outs
// export const saveTimesheetDataCallout = payload => (dispatch, getState) => {
//   dispatch(saveTechnicianCalloutRequest());
//   TechnicianTimesheet.updateTechnicianCallout(payload)
//     .then(res => {
//       dispatch(saveTechnicianCalloutSuccess(res));
//     })
//     .catch(err => dispatch(saveTechnicianCalloutError(err)));
// };
